import { DataBean } from "../DataBean";

export class PhysicalTaking extends DataBean {


    public async getPhysicalTakingCatalog(year:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getPhysicalTakingCatalog_Number", [year]);
    }

    
//aqui
 
}